import { Pipe, PipeTransform } from '@angular/core';

const types: Record<string, string> = {
  deadhead: 'Deadhead',
  det_loading: 'Loading Detention',
  linehaul: 'Linehaul',
  accessorial: 'Accessorial',
  det_unloading: 'Unloading Detention',
  fuel_surcharge: 'Fuel Surcharge',
  bonus: 'Bonus',
};

@Pipe({
  name: 'chargeType',
})
export class ChargeTypePipe implements PipeTransform {
  public transform(value: string): unknown {
    return types[value];
  }
}
